const publications = [ 
  // Wichtigste
  {
    id: 'morgenpost',
    baseUrl: 'https://interaktiv.morgenpost.de',
    homepageUrl: 'https://www.morgenpost.de',
    imprintUrl: 'https://www.morgenpost.de/impressum/',
    privacyUrl: 'https://www.morgenpost.de/datenschutz/', 
    teaserLink: 'https://interaktiv.morgenpost.de/europawahl-2019-ergebnisse/', 
    meta: {
      twSite: '@morgenpost',
      ogSiteName: 'Berliner Morgenpost'//,
      //ogTitle: 'Diese Publikation hat einen eigenen og:title...'
    },
    appearance: {
      logoPath: 'bm'
    }
  },  
  {
    id: 'abendblatt',
    baseUrl: 'https://interaktiv.abendblatt.de',
    homepageUrl: 'https://www.abendblatt.de',
    imprintUrl: 'https://www.abendblatt.de/service/unternehmen/article109174655/Impressum.html',
    privacyUrl: 'https://www.abendblatt.de/service/unternehmen/article107788715/Datenschutzerklaerung.html',
    teaserLink: 'https://interaktiv.abendblatt.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@abendblatt',
      ogSiteName: 'Hamburger Abendblatt'
    },
    appearance: {
      logoPath: 'ha'
    }
  },
  {
    id: 'derwesten',
    baseUrl: 'https://interaktiv.derwesten.de',
    homepageUrl: 'https://www.derwesten.de',
    imprintUrl: 'https://www.derwesten.de/impressum/',
    privacyUrl: 'https://www.derwesten.de/datenschutz/',
    teaserLink: 'https://interaktiv.derwesten.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@DerWesten',
      ogSiteName: 'Der Westen'
    },
    appearance: {
      logoPath: 'dwe'
    }
  },
  {
    id: 'waz',
    baseUrl: 'https://interaktiv.waz.de',
    homepageUrl: 'https://www.waz.de',
    imprintUrl: 'https://www.waz.de/impressum/',
    privacyUrl: 'https://www.waz.de/datenschutz/',
    teaserLink: 'https://interaktiv.waz.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@WAZ_Redaktion',
      ogSiteName: 'WAZ'
    },
    appearance: {
      logoPath: 'waz'
    }
  }, 
  
  // Markenportale der WAZ-Redaktion
  
  {
    id: 'nrz',
    baseUrl: 'https://interaktiv.nrz.de',
    homepageUrl: 'https://www.nrz.de',
    imprintUrl: 'https://www.nrz.de/impressum/',
    privacyUrl: 'https://www.nrz.de/datenschutz/',
    teaserLink: 'https://interaktiv.nrz.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@NRZNiederrhein',
      ogSiteName: 'NRZ'
    }
  },
  {
    id: 'wp',
    baseUrl: 'https://interaktiv.wp.de',
    homepageUrl: 'https://www.wp.de',
    imprintUrl: 'https://www.wp.de/impressum/',
    privacyUrl: 'https://www.wp.de/datenschutz/',
    teaserLink: 'https://interaktiv.wp.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@dassauerland',
      ogSiteName: 'Westfalenpost'
    },
    appearance: {
      logoPath: 'wp'
    }
  },
  {
    id: 'wr',
    baseUrl: 'https://interaktiv.wr.de',
    homepageUrl: 'https://www.wr.de',
    imprintUrl: 'https://www.wr.de/impressum/',
    privacyUrl: 'https://www.wr.de/datenschutz/',
    teaserLink: 'https://interaktiv.wr.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@WN_Redaktion',
      ogSiteName: 'Westfälische Rundschau'
    }
  },
  {
    id: 'ikz',
    baseUrl: 'https://interaktiv.ikz-online.de',
    homepageUrl: 'https://www.ikz-online.de',
    imprintUrl: 'https://www.ikz-online.de/impressum/',
    privacyUrl: 'https://www.ikz-online.de/datenschutz/',
    teaserLink: 'https://interaktiv.ikz-online.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@WAZ_Redaktion',
      ogSiteName: 'IKZ-Online'
    }
  },

  // Niedersachsen  
  {
    id: 'news38',
    baseUrl: 'https://interaktiv.news38.de',
    homepageUrl: 'https://www.news38.de',
    imprintUrl: 'https://www.news38.de/impressum/',
    privacyUrl: 'https://www.news38.de/datenschutz/',
    teaserLink: 'https://interaktiv.news38.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@news38_de',
      ogSiteName: 'news38.de'
    }
  },
  {
    id: 'braunschweiger',
    baseUrl: 'https://interaktiv.braunschweiger-zeitung.de',
    homepageUrl: 'https://www.braunschweiger-zeitung.de',
    imprintUrl: 'https://www.braunschweiger-zeitung.de/impressum/',
    privacyUrl: 'https://www.braunschweiger-zeitung.de/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.braunschweiger-zeitung.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@bs_zeitung',
      ogSiteName: 'Braunschweiger Zeitung'
    },
    appearance: {
      logoPath: 'bz'
    }
  },
  {
    id: 'wolfsburg',
    baseUrl: 'https://interaktiv.wolfsburger-nachrichten.de',
    homepageUrl: 'https://www.wolfsburger-nachrichten.de/',
    imprintUrl: 'https://www.wolfsburger-nachrichten.de/impressum/',
    privacyUrl: 'https://www.wolfsburger-nachrichten.de/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.wolfsburger-nachrichten.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@WN_Wolfsburg',
      ogSiteName: 'Wolfsburger Nachrichten'
    }
  },
  {
    id: 'salzgitter',
    baseUrl: 'https://interaktiv.salzgitter-zeitung.de',
    homepageUrl: 'https://www.salzgitter-zeitung.de',
    imprintUrl: 'https://www.salzgitter-zeitung.de/impressum/',
    privacyUrl: 'https://www.salzgitter-zeitung.de/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.salzgitter-zeitung.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@SZ_Zeitung',
      ogSiteName: 'Salzgitter Zeitung'
    }
  },
  {
    id: 'gifhorn',
    baseUrl: 'https://interaktiv.gifhorner-rundschau.de',
    homepageUrl: 'https://www.gifhorner-rundschau.de',
    imprintUrl: 'https://www.gifhorner-rundschau.de/impressum/',
    privacyUrl: 'https://www.gifhorner-rundschau.de/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.gifhorner-rundschau.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@GF_Rundschau',
      ogSiteName: 'Gifhorner Rundschau'
    }
  },
  {
    id: 'helmstedt',
    baseUrl: 'https://interaktiv.helmstedter-nachrichten.de',
    homepageUrl: 'https://www.helmstedter-nachrichten.de',
    imprintUrl: 'https://www.helmstedter-nachrichten.de/impressum/',
    privacyUrl: 'https://www.helmstedter-nachrichten.de/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.helmstedter-nachrichten.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@HE_Nachrichten',
      ogSiteName: 'Helmstedter Nachrichten'
    }
  },
  {
    id: 'peiner',
    baseUrl: 'https://interaktiv.peiner-nachrichten.de',
    homepageUrl: 'https://www.peiner-nachrichten.de',
    imprintUrl: 'https://www.peiner-nachrichten.de/impressum/',
    privacyUrl: 'https://www.peiner-nachrichten.de/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.peiner-nachrichten.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@PN_Peine',
      ogSiteName: 'Peiner Nachrichten'
    }
  },
  {
    id: 'wolfenbuettel',
    baseUrl: 'https://interaktiv.wolfenbuetteler-zeitung.de',
    homepageUrl: 'https://www.wolfenbuetteler-zeitung.de',
    imprintUrl: 'https://www.wolfenbuetteler-zeitung.de/impressum/',
    privacyUrl: 'https://www.wolfenbuetteler-zeitung.de/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.wolfenbuetteler-zeitung.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@WF_Zeitung',
      ogSiteName: 'Wolfenbütteler Zeitung'
    }
  },

  // Thüringen
  {
    id: 'ta',
    baseUrl: 'https://interaktiv.thueringer-allgemeine.de',
    homepageUrl: 'https://www.thueringer-allgemeine.de',
    imprintUrl: 'https://www.thueringer-allgemeine.de/impressum/',
    privacyUrl: 'https://www.thueringer-allgemeine.de/web/zgt/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.thueringer-allgemeine.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@TAOnline',
      ogSiteName: 'Thüringer Allgemeine'
    },
    appearance: {
      logoPath: 'ta'
    }
  },
  {
    id: 'otz',
    baseUrl: 'https://interaktiv.otz.de',
    homepageUrl: 'https://www.otz.de',
    imprintUrl: 'https://www.otz.de/impressum/',
    privacyUrl: 'https://www.otz.de/web/zgt/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.otz.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@OTZonline',
      ogSiteName: 'OTZ'
    },
    appearance: {
      logoPath: 'otz'
    }
  },
  {
    id: 'tlz',
    baseUrl: 'https://interaktiv.tlz.de',
    homepageUrl: 'https://www.tlz.de',
    imprintUrl: 'https://www.tlz.de/impressum/',
    privacyUrl: 'https://www.tlz.de/web/zgt/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.tlz.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@TLZnews',
      ogSiteName: 'Thüringische Landeszeitung'
    },
    appearance: {
      logoPath: 'tlz'
    }
  },
  {
    id: 'th24',
    baseUrl: 'https://interaktiv.thueringen24.de',
    homepageUrl: 'https://www.thueringen24.de',
    imprintUrl: 'https://www.thueringen24.de/impressum/',
    privacyUrl: 'https://www.thueringen24.de/datenschutzerklaerung/',
    teaserLink: 'https://interaktiv.thueringen24.de/europawahl-2019-ergebnisse/',
    meta: {
      twSite: '@th24deinenews',
      ogSiteName: 'Thüringen24'
    }
  }
];

module.exports = publications;
